<template>
  <div>
    <v-app-bar app flat color="#00C57E" dark clipped-left>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="d-flex align-center" style="position: relative; padding-right: 15px; height: 100%;">
        <v-img src="/img/logo-zaper.svg"></v-img>
      </v-toolbar-title>

      <v-divider class="mx-4" inset vertical></v-divider>

      <v-select
        v-if="project"
        :value="projectId"
        @change="projectId => $store.commit('projects/SET_ID', projectId)"
        :items="projects"
        item-text="name"
        item-value="id"
        hide-details
        style="max-width: 250px;"
        outlined
        dense
        :label="project.user_id !== user.id ? 'Outros projetos' : 'Meus projetos'"
      >
        <template v-slot:item="{ item }">
          <div class="caption d-flex flex-column pt-1 pb-1">
            <span class="grey--text">{{item.role}}</span>
            <span class="font-weight-medium">{{item.name}}</span>
          </div>
        </template>
        <template v-slot:append-item>
          <v-divider class="mb-2 mt-2"></v-divider>
          <v-list-item @click="createNewProject()" class="subtitle-2">
            Novo projeto
          </v-list-item>
        </template>
      </v-select>

      <v-btn icon v-if="projectId" @click="editProject = project" class="ml-1">
        <v-icon >mdi-pencil</v-icon>
      </v-btn>

      <zp-update-project :data="editProject" @close="editProject = null"></zp-update-project>

      <v-spacer></v-spacer>

      <v-btn icon @click="logout()">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      expand-on-hover
    >
      <v-list nav dense>
        <v-list-item-group v-model="path" active-class="blue--text text--accent-4">
          <v-list-item link :to="{ path: '/links' }" class="zp-header-item">
            <v-list-item-icon>
              <v-icon>mdi-link-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Meus links</v-list-item-title>
          </v-list-item>

          <v-list-item link :to="{ path: '/pixels' }">
            <v-list-item-icon>
              <v-icon>mdi-bullseye-arrow</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              Meus pixels
            </v-list-item-title>
          </v-list-item>

          <v-list-item link :to="{ path: '/dominios' }" class="zp-header-item">
            <v-list-item-icon>
              <v-icon>mdi-web</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              Meus domínios
            </v-list-item-title>
          </v-list-item>

          <v-list-item link :to="{ path: '/aprender-e-praticar' }" class="zp-header-item">
            <v-list-item-icon>
              <v-icon>mdi-school</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              Aprender e praticar
            </v-list-item-title>
          </v-list-item>

          <v-list-item link :to="{ path: '/bot' }" class="zp-header-item">
            <v-list-item-icon>
              <v-icon>mdi-robot</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Zaper bot</v-list-item-title>
          </v-list-item>

          <v-list-item link :to="{ path: '/plano' }" class="zp-header-item">
            <v-list-item-icon>
              <v-icon>mdi-lightning-bolt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Meu plano</v-list-item-title>
          </v-list-item>

          <v-list-group prepend-icon="mdi-cogs" no-action>
            <template v-slot:activator>
              <v-list-item-title>Avançado</v-list-item-title>
            </template>

            <v-list-item link :to="{ path: '/equipe' }" class="zp-header-item">
              <v-list-item-title>Equipe</v-list-item-title>
            </v-list-item>

            <v-list-item link :to="{ path: '/minhaconta' }" class="zp-header-item">
              <v-list-item-title>Informações da conta</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="user.affiliate" link :to="{ path: '/afiliado' }" class="zp-header-item">
              <v-list-item-title>Programa de afiliados</v-list-item-title>
            </v-list-item>

            <v-list-item link :to="{ path: '/privacidade' }" class="zp-header-item">
              <v-list-item-title>Privacidade</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <zp-new-project v-model="newProject"></zp-new-project>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import ZpUpdateProject from './UpdateProject'
import ZpNewProject from './NewProject'

export default {
  components: {
    ZpUpdateProject,
    ZpNewProject
  },
  data () {
    return {
      newProject: false,
      path: '',
      editProject: null,
      drawer: true,
      group: ''
    }
  },
  computed: {
    ...mapState({
      projectId: state => state.projects.id,
      _projects: state => state.projects.data,
      user: state => state.auth.user
    }),
    ...mapGetters({
      project: 'projects/getSelected'
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    projects () {
      let projects = [{ header: 'Meus projetos' }].concat(this._projects.filter(item => item.role === 'Administrador'))
      let others = this._projects.filter(item => item.role !== 'Administrador')
      
      if (others.length) {
        projects.push({ header: 'Outros projetos' })
        projects = projects.concat(others)
      }

      return projects
    }
  },
  async mounted () {
    await this.$store.dispatch('projects/index')
    this.$store.dispatch('links/storePreview')
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
      this.$router.push('/auth')
    },
    support () {
      if (this.isActivePlan) {
        window.open(`https://wa.me/551130424849?text=Olá! Sou usuário do gerenciador de links e preciso de um suporte.`, '_blank')
      } else {
        window.open('https://instagram.com/zaper.in', '_blank')
      }
    },
    createNewProject () {
      if (!this.isActivePlan) {
        return alert('Contrate um de nossos planos para liberar a criação de novos projetos :)')
      }

      this.newProject = true
    }
  }
}
</script>

<style lang="scss" scoped>
.beta {
  position: absolute;
  right: 2px;
  top: 6px;
  font-size: .5em;
  background-color: #f3d43d;
  padding: 2px;
  color: black;
  border-radius: 3px;
  padding-left: 4px;
  padding-right: 4px;
  z-index: 2;
}

.new {
  position: absolute;
  right: 10px;
  top: 8px;
  font-size: .8em;
  padding: 3px;
  color: black;
  border-radius: 3px;
  padding-left: 4px;
  padding-right: 4px;
  background-color: #f3d43d;
  z-index: 2;
}

.zp-header-item {
  position: relative;
  padding-right: 15px;
  height: 100%;
}
</style>
